import logo from './logo.svg';
import './App.css';

function App() {
	return (
		<div className='App'>
			<header className='App-header'>
				<img src={logo} className='App-logo' alt='logo' />
				<p>The cutest kid in the universe.</p>
			</header>
		</div>
	);
}

export default App;
